import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
export const useCartStore = defineStore('cartStore', () => {
    const initialized = ref(false);
    const coupons = ref([]);
    const giftsAvailable = ref(0);
    const gifts = ref([]);
    const giftsUsed = computed(() => gifts.value.length);
    const giftsLeft = computed(() => giftsAvailable.value - giftsUsed.value);
    const giftable = ref([]);
    const giftsMinOrderSum = ref(0);
    const giftsVipMinOrderSum = ref(0);
    const products = ref([]);
    const bottles = computed(() => products.value.reduce((sum, product) => {
        return product.category === 'atomizers' ? sum : sum + product.quantity;
    }, 0));
    const totalSum = ref(0);
    const totalDiscount = ref(0);
    const vipAvailable = computed(() => totalSum.value >= giftsVipMinOrderSum.value);
    watch(vipAvailable, (value, oldValue) => {
        if (!value && oldValue) {
            gifts.value = gifts.value.filter(gift => !gift.vip);
        }
    });
    function setCoupons(newCoupons) {
        coupons.value = newCoupons;
    }
    function setProducts(newProducts) {
        products.value = newProducts;
    }
    function getProduct(productId) {
        return products.value.find(product => product.cartItemId === productId);
    }
    function removeProduct(cartItemId) {
        if (!products.value.find(product => product.cartItemId === cartItemId)) {
            return false;
        }
        products.value = products.value.filter(product => cartItemId !== product.cartItemId);
        return true;
    }
    function setTotals(sum, discount) {
        totalSum.value = sum;
        totalDiscount.value = discount;
    }
    function addCoupon(code) {
        if (coupons.value.find(coupon => code.toLowerCase() === coupon.code.toLowerCase())) {
            return false;
        }
        coupons.value.push({ code, ghost: true });
        return true;
    }
    function removeCoupon(code) {
        if (!coupons.value.find(coupon => code === coupon.code)) {
            return false;
        }
        coupons.value = coupons.value.filter(coupon => code !== coupon.code);
        return true;
    }
    function setAvailable(available) {
        giftsAvailable.value = available;
        if (gifts.value.length > available) {
            gifts.value = gifts.value.slice(0, available);
        }
    }
    function setGifts(newGifts) {
        gifts.value = newGifts;
    }
    function setGiftableProducts(newGiftable) {
        giftable.value = newGiftable.sort((a, b) => a.name.localeCompare(b.name));
    }
    function addGift(productId) {
        const gift = giftable.value.find(gift => gift.productId === productId);
        if (!gift) {
            return false;
        }
        gifts.value.push(gift);
        return true;
    }
    function removeGift(productId) {
        const newGifts = gifts.value.filter(gift => gift.productId !== productId);
        if (newGifts.length === gifts.value.length) {
            return false;
        }
        gifts.value = newGifts;
        return true;
    }
    function setGiftLimits(minAmount, vipAmount) {
        giftsMinOrderSum.value = minAmount;
        giftsVipMinOrderSum.value = vipAmount;
    }
    return {
        initialized,
        // Gifts
        gifts, giftable, giftsAvailable, giftsUsed, giftsLeft, vipAvailable, giftsMinOrderSum, giftsVipMinOrderSum,
        setAvailable, setGifts, setGiftableProducts, addGift, removeGift, setGiftLimits,
        // Coupons
        coupons,
        setCoupons, addCoupon, removeCoupon,
        // Products
        products, bottles,
        getProduct, setProducts, removeProduct,
        // Totals
        totalSum, totalDiscount,
        setTotals,
    };
});
